<template>
  <div>
    <div class="row">
      <div class="col flow-text"><h5>Formulario de Recepciones</h5></div>
    </div>
    <div class="row">
      <div class="col s12 input-field">
        <label class="active" for="event_status">Status del carton</label>
        <input
          type="text"
          id="event_status"
          v-model="event_status"
          disabled
          list="status"
        />
        <datalist id="status">
          <option>Recibido en tienda</option>
          <option>Recibido en almacén</option>
        </datalist>
      </div>
    </div>
   
    <div>
      <!--  Action button  -->
      <div class="fixed-action-btn">
        <button
          v-if="!cargando"
          @click="save"
          class="btn-floating btn-large blue"
        >
          <i class="large material-icons">save</i>
        </button>
        <div v-else class="preloader-wrapper active">
          <div class="spinner-layer spinner-red-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>
      <!--  /Action button  -->
    </div>
  </div>
</template>
<script>
import M from "materialize-css";
//import firebase from "firebase/app";
import Helpers from "../../../../../helpers";
import { EVENT_CARTON_EN_ALMACEN, ENV } from "@/constants";
import Domicilios from "@/tracker/recursos/almacenes_domicilios.json";
import { updateCartons } from "@/tracker/firebase_models/updateCartons";
export default {
  name: "formulario-recepcion",
  props: {
    db: Object,
    shipvia: Object,
    almacen: Object,
    cartons: Object,
    shipvias: Array,
  },
  components: {},

  data() {
    return {
      cargando: false,
      domicilios: Domicilios,
      event_status: "Recibido en tienda",
      incoming_jobs: {},
    };
  },
  computed: {
    shipments_in_cartons() {
      let cartons = Object.values(this.cartons),
        shipments = {};
        cartons.forEach((carton) => {
          if (carton.shipmentid)
            if (!shipments[carton.shipmentid]) shipments[carton.shipmentid] = true;
        });
      return Object.keys(shipments).map(e=>parseInt(e));
    },
    incoming_jobs_list() {
      let incoming_jobs = { ...this.incoming_jobs };
      
      return incoming_jobs;
    },
    jobs_in_cartons() {
      let cartons = Object.values(this.cartons),
        ccmasterids = {};
      cartons.forEach((carton) => {
        if (!ccmasterids[carton.ccmasterid])
          ccmasterids[carton.ccmasterid] = {};
        ccmasterids[carton.ccmasterid][carton.jobpart] = true;
      });
      // Object.keys(ccmasterids).forEach((key) => {
      //   ccmasterids[key] = Object.keys(ccmasterids[key]);
      // });
      return ccmasterids;
    },
    sucursal() {
      return this.domicilios[this.almacen.iclocid] || {};
    },

    evento() {
      let desc = `Recibido en ${this.almacen.iclocdesc} por ${window.user.displayName}.`;
      return Helpers.createCartonEvent(
        this.event_status,
        desc,
        window.user.email,
      );
    },
  },
  methods: {
  verificarTodosLosCartones(apiResponseBody) {
      // 1. Validar que la respuesta sea un array válido y no esté vacío
      if (!Array.isArray(apiResponseBody) || apiResponseBody.length === 0) {
          return true; // No hay errores, el flujo continúa normalmente
      }

      // 2. Recorrer cada uno de los errores del response body
      for (let i = 0; i < apiResponseBody.length; i++) {
          const error = apiResponseBody[i];
          const { missing_qty, planned_quantity, job, shipmentid, scaned_cartons } = error;

          // Construir el mensaje dinámico para el error actual
          const mensaje = `⚠️ ¡ATENCIÓN! Faltan ${missing_qty} pieza(s) 📦 de las ${planned_quantity} piezas que conforman el pedido ${job} (Envío ID: ${shipmentid}). Cartones escaneados: ${scaned_cartons} \n\n` +
                          `🚛 Confirma esto con el chofer antes de confirmar la recepción.\n\n` +
                          `🛑 Presiona Cancelar para continuar. (${i + 1} de ${apiResponseBody.length})`;


          // Mostrar el confirm para este error específico
          while(confirm(mensaje));
      }

      // Si terminó de revisar todos los errores y en todos presionó "Cancelar"
      return true; 
    },
    mark_as_shipped(cartons, idToken) {
      let uri = ENV.VUE_APP_N8N_ALMACEN_RECEPCION_WEBHOOK_URL;
      return fetch(
        uri,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-Authorization": "Bearer " + idToken,
          },
          body: JSON.stringify({cartons:cartons, shipvia:this.shipvia}),
        },
      );
    },
    notifyEmail() {
      let template_data = {
        sucursal: this.sucursal.name,
        domicilio: this.sucursal.address,
        tels: this.sucursal.tels.join(", "),
      };
      Helpers.notifyEmail(this.cartons, "soltar-en-sucursal", template_data);
    },
    async save() {
      if (!this.almacen)
        return M.toast({
          html: "No has seleccionado un almacen",
          classes: "orange",
        });
      let user = window.user,
        batch = {}, // Definimos un lote de registros
        //shipvia = this.shipvia.shipviadesc,
        almacen = this.almacen,
        //shipvia = this.shipvia,
        cartons = this.cartons,
        cartons_keys = Object.keys(cartons).filter((cartonId) => {
          // Buscamos paquetes foraneos
          let carton = cartons[cartonId];

          if (
            !this.shipvia ||
            !this.shipvia.syshipviaid ||
            carton.shipviaid == this.shipvia.syshipviaid
          )
            return true;
          else
            return confirm(
              `El paquete ${cartonId} tiene asiganada una vía de envío distinta a la seleccionada. ¿Deseas conservarlo?`,
            );
        });
      if (!cartons_keys.length)
        return M.toast({
          html: "No se guardó ningún paquete",
          classes: "orange",
        });

      cartons_keys.forEach((cartonId) => {
        // Por cada carton
        let carton_data = cartons[cartonId];
        //docRef = Carton.docRef(cartonId, this.db); // Referencia a un documento
        // Agrega información al documento

        carton_data.status = this.evento.status;
        carton_data.status_desc = this.evento.desc;
        carton_data.status_code = EVENT_CARTON_EN_ALMACEN;

        // Agrega evento
        let event_data = {
          ...this.evento,
          status_code: carton_data.status_code,
        };
        carton_data["ARRAY_UNION.eventos"] = event_data;

        carton_data.location = almacen.iclocdesc;
        carton_data.iclocdesc = almacen.iclocdesc;
        carton_data.iclocid = almacen.iclocid;
        // carton_data.shipviaid = shipvia.syshipviaid || carton_data.shipviaid;
        // carton_data.shipviadesc = shipvia.sydescription || carton_data.shipviadesc;
        carton_data.descargado = "SERVER_TIMESTAMP";

        // informacion sobre usuario
        carton_data.last_user_email = user.email;
        // timestamps
        carton_data.updated_at = "SERVER_TIMESTAMP";
        carton_data.updated = new Date().toLocaleString();
        // Sino existe el documento se crea con la información, si existe se actualiza.
        batch[cartonId] = carton_data;
        //resplado en base de datos mongo
        //Carton.backupDoc({ _id: cartonId, ...carton_data });
      });
      this.cargando = true;
      let idToken = await window.user.getIdToken();
      updateCartons(batch, idToken)
        .then(() => {
          // Notificar por correo
          if (ENV.VUE_APP_ENV !== "dev") {
            try {
              this.notifyEmail();
            } catch (err) {
              console.log(err);
            }
          }
          if (Object.keys(this.incoming_jobs_list).length) 
          this.mark_as_shipped(this.cartons, idToken)
            .then((res) => {
              if (!res.ok) {
                console.log(
                  "Error al actualizar estado de branch shipment",
                  res,
                );
              } else {
                res.json().then((data) => {
                  if ("errors" in data) {
                    this.verificarTodosLosCartones(data.errors);
                  } else {
                    console.log("Branch shipment actualizado");
                  }
                });
              }
            })
            .catch((err) => {
              console.log("Error al actualizar estado de branch shipment", err);
            })
          //despachar evento para limpiar tablas
          document.dispatchEvent(new Event("limpiarEscaneos"));
          //Todo es correcto
          M.toast({ html: "Guardado exitosamente", classes: "green" });
        })
        .catch((err) => {
          console.log("Error", err);
          if (err.code === "not-found")
            alert(
              "Uno de los cartones no está registrado. Reporta este incidente a tu supervisor y muestra la siguiente información: " +
                err.message,
            );
          else
            M.toast({
              html: "Ha ocurrido un error: " + err.message,
              classes: "red",
            });
        })
        .finally(() => {
          this.cargando = false;
        });
    },
  },
  watch: {
    jobs_in_cartons(newVal) {
      let incoming_jobs = { ...newVal };
      this.incoming_jobs = incoming_jobs;
    },
  },
};
</script>
